import * as yup from "yup";

const coinSchema = (translate: Function) => yup.object().shape({
	moa001Descricao: yup.string().required(translate("Descrição da moeda é requerida")),
	moa001Sigla: yup.string().required(translate("Sigla é requerida"))
});

export default  coinSchema;
